module.exports = __webpack_public_path__ + "img/CLD_logo_poweredBy.edc649c9.png";